import gql from 'graphql-tag';

export default gql`
  mutation ($_id: MongoID!, $index: Float) {
    updateCourseItem(_id: $_id, record: { index: $index }) {
      recordId
    }
  }
`;
